import React, { useEffect, useState } from "react";
import { Bar } from "@ant-design/plots";
import queryKeys from "common/queryKey";
import moment from "moment";
import { getClientid } from "redux/selectors";
import { connect } from "react-redux";
import { useFetch } from "hooks/useFetch";
import { Spin } from "antd";
import DetailsModal from "organisms/DetailsModal";

function AttritionByGradeCode({ value, clientid }) {
  const [dataList, setDataList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [plotData, setPlotData] = useState("");


  const { getAttritionByGradeCode, getConfiguration } = queryKeys;

  const payload = {
    method: "attritionByGradeCode",
    parameters: {
      startDate: value?.date ? moment(value.date).format("YYYY-MM-DD") : "",
      endDate: value?.end_date
        ? moment(value.end_date).format("YYYY-MM-DD")
        : "",
      managingOffice: value?.managingoffice || [],
      competencyQC: value?.competencyQC || [],
      officesupervisor: value?.officesupervisor || "",
    },
  };

  const payloadString = JSON.stringify(payload);
  const { key, url } = getAttritionByGradeCode(clientid, payloadString);

  const { data, isLoading, refetch } = useFetch(
    key,
    url,
    {
      enabled: !!clientid,
    },
    payload
  );

  const { key: configurationKey, url: configurationUrl } = getConfiguration();
  const { data: configurationData, isLoading: isConfigurationLoading } = useFetch(
    configurationKey,
    configurationUrl,
    {
      enabled: !!clientid,
    }
  );

  useEffect(() => {
    const gradeConfigurations = configurationData?.response?.items?.filter(
      (item) => item.configurationName === "chargeout" && item.jobgradecode
    );
    if (!gradeConfigurations) return;

    const grades = [
      ...new Map(
        gradeConfigurations.map((item) => [item.jobgradecode, item])
      ).values(),
    ].sort((first, second) =>
      String(first.jobgradecode).localeCompare(String(second.jobgradecode))
    );
    const attritionByGrade = (data?.response?.attritionByGradeCode || []).reduce(
      (counts, employee) => {
        counts[employee.grade] = (counts[employee.grade] || 0) + 1;
        return counts;
      },
      {}
    );

    setDataList(
      grades.map(({ jobgradecode }) => ({
        xValue: jobgradecode,
        listItem: [jobgradecode],
        Count: attritionByGrade[jobgradecode] || 0,
      }))
    );
  }, [configurationData, data]);

  const plotClick = () =>{
    if (plotData?.data?.data) {
      const filterData = data?.response?.attritionByGradeCode?.filter(
        (item) => plotData.data.data.listItem?.includes(item?.grade)
      );
      setTableData(filterData);
      setIsModalVisible(true);
    }
}

useEffect(()=>{
    if(plotData !== ""){
    plotClick();
    }
},[plotData])

  const config = {
    data: dataList,
    xField: "Count",
    yField: "xValue",
    animation: false,
    color: "#9CD3FA",
    onReady: (plot) => {
      plot.on("plot:click", (evt) => {
        setPlotData(evt);
      });
    },
    label: {
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
    xAxis: {
      tickInterval: 3,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
  };

  return (
    <>
      <h6 className="mt-2">Attrition By Grade Code:</h6>
      <div className="box-container">
        <Spin spinning={isLoading || isConfigurationLoading}>
          <Bar {...config} />
        </Spin>
      </div>
      <DetailsModal
        isopen={isModalVisible}
        isCancel={() => setIsModalVisible(false)}
        tabledata={tableData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  clientid: getClientid(state),
});

export default connect(mapStateToProps, null)(AttritionByGradeCode);
